import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=f47b24f2&scoped=true&"
import script from "./appMain.vue?vue&type=script&lang=js&"
export * from "./appMain.vue?vue&type=script&lang=js&"
import style0 from "./appMain.vue?vue&type=style&index=0&id=f47b24f2&lang=scss&scoped=true&"
import style1 from "./appMain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b24f2",
  null
  
)

export default component.exports